(function () {
  if (!document.body.classList.contains('template--product')) return;

  var TRUST_ICON =
    'https://cdn.shopify.com/s/files/1/0073/0402/0066/files/0c42a7b2953db634be9603f6e761db09163e5d5e.png?v=1791545489';
  var CHECK_SVG =
    '<svg viewBox="0 0 16 16" aria-hidden="true"><circle cx="8" cy="8" r="8" fill="#0065A4"></circle><path d="M4.4 8.2 6.7 10.4 11.6 5.6" fill="none" stroke="#fff" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
  var FILTER_SVG =
    '<svg class="kg-reviews-filter__icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#231F20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="2" y1="3" x2="18" y2="3"></line><line x1="2" y1="12" x2="10" y2="12"></line><line x1="2" y1="21" x2="8" y2="21"></line><line x1="17" y1="8" x2="17" y2="21"></line><polyline points="12,16 17,21 22,16"></polyline></svg>';

  var root = null;
  var loadingMore = false;
  var building = false;

  function shopDomain() {
    return (window.Shopify && window.Shopify.shop) || 'slicingeasy.myshopify.com';
  }

  function shopUrl() {
    return window.location.hostname.indexOf('kookgigant') !== -1 ? window.location.hostname : 'kookgigant.nl';
  }

  function productId() {
    var info = document.querySelector('product-info[data-product-id]');
    return info ? info.getAttribute('data-product-id') : '';
  }

  function reviewsUrl(id, page, perPage) {
    return (
      'https://judge.me/reviews/reviews_for_widget?url=' +
      encodeURIComponent(shopUrl()) +
      '&shop_domain=' +
      encodeURIComponent(shopDomain()) +
      '&platform=shopify&page=' +
      page +
      '&per_page=' +
      perPage +
      '&product_id=' +
      encodeURIComponent(id)
    );
  }

  function scoreOf(review) {
    var rating = review.querySelector('.jdgm-rev__rating');
    var score = rating ? parseFloat(rating.getAttribute('data-score')) : 0;
    return isNaN(score) ? 0 : score;
  }

  function starSpans(score) {
    var html = '';
    var value = Math.round(Number(score) * 2) / 2;
    var i;
    for (i = 1; i <= 5; i += 1) {
      var state = 'jdgm--off';
      if (value >= i) state = 'jdgm--on';
      else if (value >= i - 0.5) state = 'jdgm--half';
      html += '<span class="jdgm-star ' + state + '"></span>';
    }
    return html;
  }

  function histogramHtml(counts, total) {
    var html = '<div class="jdgm-histogram">';
    var rating;
    for (rating = 5; rating >= 1; rating -= 1) {
      var frequency = counts[rating] || 0;
      var percentage = total ? Math.round((frequency / total) * 100) : 0;
      html +=
        '<div class="jdgm-histogram__row" data-rating="' +
        rating +
        '" data-frequency="' +
        frequency +
        '" data-percentage="' +
        percentage +
        '">' +
        '<div class="jdgm-histogram__star">' +
        rating +
        '</div>' +
        '<div class="jdgm-histogram__bar"><div class="jdgm-histogram__bar-content" style="width:' +
        percentage +
        '%"></div></div>' +
        '<div class="jdgm-histogram__percentage">' +
        percentage +
        '%</div></div>';
    }
    html += '</div>';
    return html;
  }

  function carouselBlock(carousel) {
    return carousel.closest('.shopify-app-block') || carousel.closest('.jdgm-widget') || carousel;
  }

  function hideCarousels() {
    document.querySelectorAll('.jdgm-carousel-wrapper, .jdgm-widget.jdgm-carousel').forEach(function (carousel) {
      carouselBlock(carousel).style.setProperty('display', 'none', 'important');
    });
  }

  function reviewCount(widget) {
    var count = parseInt(widget.getAttribute('data-number-of-reviews'), 10);
    return isNaN(count) ? 0 : count;
  }

  var COPY = {
    en: {
      trusted: 'Trusted shops',
      title: 'Customer reviews',
      basedOn: 'Based on {{count}}',
      review: 'review',
      reviews: 'reviews',
      write: 'Write A Review',
      filter: 'Filter',
      showMore: 'Show More',
      verified: 'Verified',
      by: 'by',
      sortRecent: 'Most recent',
      sortHighest: 'Highest rating',
      sortLowest: 'Lowest rating',
      close: 'Close',
      rating: 'Rating',
      name: 'Name',
      email: 'Email',
      reviewTitle: 'Title',
      reviewBody: 'Review',
      submit: 'Submit Review',
      errorRating: 'Choose a star rating.',
      errorRequired: 'Name, email, and review are required.',
      errorSubmit: 'Your review could not be submitted. Please try again.',
      success: 'Thank you. Your review will be published after the store approves it.',
      star: '{{count}} star',
      stars: '{{count}} stars',
      scoreLabel: '{{score}} stars',
      dateLocale: 'en-GB'
    },
    nl: {
      trusted: 'Trusted shops',
      title: 'Klantbeoordelingen',
      basedOn: 'Gebaseerd op {{count}}',
      review: 'beoordeling',
      reviews: 'beoordelingen',
      write: 'Schrijf een beoordeling',
      filter: 'Filter',
      showMore: 'Meer tonen',
      verified: 'Geverifieerd',
      by: 'van',
      sortRecent: 'Meest recent',
      sortHighest: 'Hoogste beoordeling',
      sortLowest: 'Laagste beoordeling',
      close: 'Sluiten',
      rating: 'Beoordeling',
      name: 'Naam',
      email: 'E-mailadres',
      reviewTitle: 'Titel',
      reviewBody: 'Beoordeling',
      submit: 'Beoordeling indienen',
      errorRating: 'Kies een sterrenbeoordeling.',
      errorRequired: 'Naam, e-mailadres en beoordeling zijn verplicht.',
      errorSubmit: 'Je beoordeling kon niet worden verzonden. Probeer het opnieuw.',
      success: 'Bedankt. Je beoordeling wordt geplaatst nadat de winkel deze heeft goedgekeurd.',
      star: '{{count}} ster',
      stars: '{{count}} sterren',
      scoreLabel: '{{score}} sterren',
      dateLocale: 'nl-NL'
    },
    de: {
      trusted: 'Trusted shops',
      title: 'Kundenbewertungen',
      basedOn: 'Basierend auf {{count}}',
      review: 'Bewertung',
      reviews: 'Bewertungen',
      write: 'Bewertung schreiben',
      filter: 'Filter',
      showMore: 'Mehr anzeigen',
      verified: 'Verifiziert',
      by: 'von',
      sortRecent: 'Neueste',
      sortHighest: 'Höchste Bewertung',
      sortLowest: 'Niedrigste Bewertung',
      close: 'Schließen',
      rating: 'Bewertung',
      name: 'Name',
      email: 'E-Mail',
      reviewTitle: 'Titel',
      reviewBody: 'Bewertung',
      submit: 'Bewertung absenden',
      errorRating: 'Wähle eine Sternebewertung.',
      errorRequired: 'Name, E-Mail und Bewertung sind erforderlich.',
      errorSubmit: 'Deine Bewertung konnte nicht gesendet werden. Bitte versuche es erneut.',
      success: 'Danke. Deine Bewertung wird veröffentlicht, sobald der Shop sie freigegeben hat.',
      star: '{{count}} Stern',
      stars: '{{count}} Sterne',
      scoreLabel: '{{score}} Sterne',
      dateLocale: 'de-DE'
    },
    fr: {
      trusted: 'Trusted shops',
      title: 'Avis clients',
      basedOn: 'Basé sur {{count}}',
      review: 'avis',
      reviews: 'avis',
      write: 'Écrire un avis',
      filter: 'Filtrer',
      showMore: 'Voir plus',
      verified: 'Vérifié',
      by: 'par',
      sortRecent: 'Plus récents',
      sortHighest: 'Meilleure note',
      sortLowest: 'Note la plus basse',
      close: 'Fermer',
      rating: 'Note',
      name: 'Nom',
      email: 'E-mail',
      reviewTitle: 'Titre',
      reviewBody: 'Avis',
      submit: 'Envoyer l’avis',
      errorRating: 'Choisis une note.',
      errorRequired: 'Le nom, l’e-mail et l’avis sont obligatoires.',
      errorSubmit: 'Ton avis n’a pas pu être envoyé. Réessaie.',
      success: 'Merci. Ton avis sera publié après validation par la boutique.',
      star: '{{count}} étoile',
      stars: '{{count}} étoiles',
      scoreLabel: '{{score}} étoiles',
      dateLocale: 'fr-FR'
    },
    es: {
      trusted: 'Trusted shops',
      title: 'Opiniones de clientes',
      basedOn: 'Basado en {{count}}',
      review: 'opinión',
      reviews: 'opiniones',
      write: 'Escribir una opinión',
      filter: 'Filtrar',
      showMore: 'Mostrar más',
      verified: 'Verificado',
      by: 'de',
      sortRecent: 'Más recientes',
      sortHighest: 'Mayor puntuación',
      sortLowest: 'Menor puntuación',
      close: 'Cerrar',
      rating: 'Valoración',
      name: 'Nombre',
      email: 'Correo electrónico',
      reviewTitle: 'Título',
      reviewBody: 'Opinión',
      submit: 'Enviar opinión',
      errorRating: 'Elige una valoración.',
      errorRequired: 'El nombre, el correo y la opinión son obligatorios.',
      errorSubmit: 'No se ha podido enviar tu opinión. Inténtalo de nuevo.',
      success: 'Gracias. Tu opinión se publicará cuando la tienda la apruebe.',
      star: '{{count}} estrella',
      stars: '{{count}} estrellas',
      scoreLabel: '{{score}} estrellas',
      dateLocale: 'es-ES'
    }
  };

  function localeCode() {
    var code = (window.Shopify && window.Shopify.locale) || document.documentElement.lang || 'nl';
    code = String(code).toLowerCase().split('-')[0];
    return COPY[code] ? code : 'en';
  }

  function t(key) {
    var pack = COPY[localeCode()] || COPY.en;
    return pack[key] || COPY.en[key] || '';
  }

  function fill(template, values) {
    return String(template).replace(/\{\{(\w+)\}\}/g, function (_, key) {
      return values[key] == null ? '' : values[key];
    });
  }

  function reviewLabel(count) {
    return count + ' ' + (count === 1 ? t('review') : t('reviews'));
  }

  function formatDate(value) {
    var date = new Date(value);
    if (isNaN(date.getTime())) return '';
    return new Intl.DateTimeFormat(t('dateLocale'), {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      timeZone: 'Europe/Amsterdam'
    }).format(date);
  }

  function place(widgetRoot) {
    if (widgetRoot.closest('.kg-reviews-host')) return;
    var host = document.createElement('div');
    host.className = 'kg-reviews-host';
    var product = document.querySelector('product-info .product');
    var block = widgetRoot.closest('.shopify-app-block');
    var node = block && block.contains(widgetRoot) ? block : widgetRoot;
    if (product && product.parentNode) {
      product.insertAdjacentElement('afterend', host);
    } else if (node.parentNode) {
      node.parentNode.insertBefore(host, node);
    }
    host.appendChild(node);
  }

  function setText(el, value) {
    if (!el) return;
    if (el.textContent !== value) el.textContent = value;
  }

  function ensureCard(widget) {
    var header = widget.querySelector('.jdgm-rev-widg__header');
    if (!header) return;

    if (!header.querySelector('.kg-reviews-trust')) {
      var trust = document.createElement('div');
      trust.className = 'kg-reviews-trust';
      trust.innerHTML = '<img src="' + TRUST_ICON + '" alt="" width="32" height="32"><span></span>';
      header.insertBefore(trust, header.firstChild);
    }
    setText(header.querySelector('.kg-reviews-trust span'), t('trusted'));

    var title = header.querySelector('.jdgm-rev-widg__title');
    setText(title, t('title'));

    var count = reviewCount(widget);
    var average = parseFloat(widget.getAttribute('data-average-rating'));
    if (isNaN(average)) average = 0;
    var score = header.querySelector('.kg-reviews-score');
    if (!score) {
      score = document.createElement('div');
      score.className = 'kg-reviews-score';
      if (title) title.insertAdjacentElement('afterend', score);
      else header.appendChild(score);
    }
    var scoreHtml =
      '<span class="kg-reviews-score__value">' +
      average.toFixed(1) +
      '</span><span class="kg-reviews-score__max"> / 5.0</span>';
    if (score.innerHTML !== scoreHtml) score.innerHTML = scoreHtml;

    var summaryText = header.querySelector('.jdgm-rev-widg__summary-text');
    setText(summaryText, fill(t('basedOn'), { count: reviewLabel(count) }));
    var summaryStars = header.querySelector('.jdgm-rev-widg__summary-stars');
    if (summaryStars) summaryStars.setAttribute('aria-label', fill(t('scoreLabel'), { score: average.toFixed(1) }));

    header.querySelectorAll('.jdgm-histogram__row[data-rating]').forEach(function (row) {
      var star = row.querySelector('.jdgm-histogram__star');
      setText(star, row.getAttribute('data-rating'));
      if (!row.querySelector('.jdgm-histogram__percentage')) {
        var percentage = document.createElement('div');
        percentage.className = 'jdgm-histogram__percentage';
        percentage.textContent = (row.getAttribute('data-percentage') || '0') + '%';
        row.appendChild(percentage);
      }
      if (!row.classList.contains('kg-reviews-zero')) {
        row.setAttribute('role', 'button');
        row.setAttribute('tabindex', '0');
      }
    });
    ensureWrite(widget);
    bindHistogram(widget);

    var histogram = header.querySelector('.jdgm-histogram');
    if (histogram && !histogram.querySelector('.kg-reviews-zero')) {
      var zero = document.createElement('div');
      zero.className = 'jdgm-histogram__row kg-reviews-zero';
      zero.setAttribute('data-rating', '0');
      zero.setAttribute('data-frequency', '0');
      zero.setAttribute('data-percentage', '0');
      zero.innerHTML =
        '<div class="jdgm-histogram__star">0</div>' +
        '<div class="jdgm-histogram__bar"><div class="jdgm-histogram__bar-content" style="width:0%"></div></div>' +
        '<div class="jdgm-histogram__percentage">0%</div>';
      var clear = histogram.querySelector('.jdgm-histogram__clear-filter');
      if (clear) histogram.insertBefore(zero, clear);
      else histogram.appendChild(zero);
    }

    var writeButton = header.querySelector('.kg-reviews-write');
    if (histogram && writeButton && writeButton.previousElementSibling !== histogram) {
      histogram.insertAdjacentElement('afterend', writeButton);
    }
  }

  function ensureWrite(widget) {
    var header = widget.querySelector('.jdgm-rev-widg__header');
    if (!header) return;
    var legacy = header.querySelector('.jdgm-write-rev-link');
    if (legacy) legacy.remove();
    var button = header.querySelector('.kg-reviews-write');
    if (!button) {
      button = document.createElement('button');
      button.type = 'button';
      button.className = 'kg-reviews-write';
      var histogram = header.querySelector('.jdgm-histogram');
      if (histogram) histogram.insertAdjacentElement('afterend', button);
      else header.appendChild(button);
    }
    setText(button, t('write'));
    if (button.getAttribute('data-kg-bound') === 'true') return;
    button.setAttribute('data-kg-bound', 'true');
    button.addEventListener('click', function () {
      openReviewForm(widget);
    });
  }

  function bindHistogram(widget) {
    var histogram = widget.querySelector('.jdgm-histogram');
    if (!histogram || histogram.getAttribute('data-kg-bound') === 'true') return;
    histogram.setAttribute('data-kg-bound', 'true');
    histogram.addEventListener('click', function (event) {
      var row = event.target.closest('.jdgm-histogram__row');
      if (!row || row.classList.contains('kg-reviews-zero')) return;
      event.preventDefault();
      event.stopPropagation();
      selectRating(widget, row.getAttribute('data-rating'));
    });
    histogram.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      var row = event.target.closest('.jdgm-histogram__row');
      if (!row || row.classList.contains('kg-reviews-zero')) return;
      event.preventDefault();
      selectRating(widget, row.getAttribute('data-rating'));
    });
  }

  function selectRating(widget, rating) {
    var next = String(rating || '');
    if (!next || next === '0') return;
    if (widget.getAttribute('data-kg-filter') === next) next = '';
    if (next) widget.setAttribute('data-kg-filter', next);
    else widget.removeAttribute('data-kg-filter');
    var histogram = widget.querySelector('.jdgm-histogram');
    if (histogram) {
      histogram.querySelectorAll('.jdgm-histogram__row').forEach(function (row) {
        var selected = next && row.getAttribute('data-rating') === next;
        row.classList.toggle('jdgm-histogram__row--selected', selected);
        row.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
    }
    if (widget._kgAll) {
      applyLocalSort(widget, widget.getAttribute('data-kg-sort') || 'recent');
      return;
    }
    if (window.jdgm && typeof window.jdgm.filterReviewsByRating === 'function' && window.jdgm.$) {
      window.jdgm.filterReviewsByRating(next || null, window.jdgm.$(widget));
    }
  }

  function reviewProductId(widget) {
    var holder = widget.closest('[data-product-id]');
    return (holder && holder.getAttribute('data-product-id')) || productId();
  }

  function starButton(score) {
    return (
      '<button type="button" class="kg-reviews-form__star" data-score="' +
      score +
      '" aria-label="' +
      fill(score === 1 ? t('star') : t('stars'), { count: score }) +
      '"><span class="jdgm-star jdgm--off"></span></button>'
    );
  }

  function paintFormStars(form, score) {
    form.querySelectorAll('.kg-reviews-form__star').forEach(function (button) {
      var value = parseInt(button.getAttribute('data-score'), 10);
      var star = button.querySelector('.jdgm-star');
      var on = value <= score;
      button.classList.toggle('is-on', on);
      button.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (star) {
        star.classList.toggle('jdgm--on', on);
        star.classList.toggle('jdgm--off', !on);
      }
    });
    var input = form.querySelector('input[name="rating"]');
    if (input) input.value = score ? String(score) : '';
  }

  function openReviewForm(widget) {
    var host = widget.closest('.kg-reviews-host') || document.body;
    var modal = host.querySelector('.kg-reviews-modal');
    if (!modal) {
      modal = document.createElement('div');
      modal.className = 'kg-reviews-modal';
      modal.hidden = true;
      modal.innerHTML =
        '<div class="kg-reviews-modal__backdrop" data-kg-close></div>' +
        '<div class="kg-reviews-modal__panel" role="dialog" aria-modal="true" aria-labelledby="kg-reviews-form-title">' +
        '<button type="button" class="kg-reviews-modal__close" data-kg-close aria-label="' + t('close') + '">&times;</button>' +
        '<h3 id="kg-reviews-form-title">' + t('write') + '</h3>' +
        '<form class="kg-reviews-form">' +
        '<div class="kg-reviews-form__stars" role="group" aria-label="' + t('rating') + '">' +
        starButton(1) + starButton(2) + starButton(3) + starButton(4) + starButton(5) +
        '</div>' +
        '<input type="hidden" name="rating" value="">' +
        '<label>' + t('name') + '<input name="name" type="text" required autocomplete="name"></label>' +
        '<label>' + t('email') + '<input name="email" type="email" required autocomplete="email"></label>' +
        '<label>' + t('reviewTitle') + '<input name="title" type="text"></label>' +
        '<label>' + t('reviewBody') + '<textarea name="body" rows="4" required></textarea></label>' +
        '<p class="kg-reviews-form__error" hidden></p>' +
        '<button type="submit" class="kg-reviews-form__submit">' + t('submit') + '</button>' +
        '</form>' +
        '<p class="kg-reviews-form__success" hidden></p>' +
        '</div>';
      host.appendChild(modal);
      modal.addEventListener('click', function (event) {
        if (event.target.closest('[data-kg-close]')) closeReviewForm(modal);
        var star = event.target.closest('.kg-reviews-form__star');
        if (star) paintFormStars(modal.querySelector('.kg-reviews-form'), parseInt(star.getAttribute('data-score'), 10));
      });
      modal.querySelector('.kg-reviews-form').addEventListener('submit', function (event) {
        event.preventDefault();
        submitReview(modal, widget);
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !modal.hidden) closeReviewForm(modal);
      });
    }
    var form = modal.querySelector('.kg-reviews-form');
    var success = modal.querySelector('.kg-reviews-form__success');
    form.hidden = false;
    success.hidden = true;
    modal.hidden = false;
    var name = form.querySelector('input[name="name"]');
    if (name) name.focus();
  }

  function closeReviewForm(modal) {
    modal.hidden = true;
  }

  function formError(modal, message) {
    var error = modal.querySelector('.kg-reviews-form__error');
    error.hidden = !message;
    error.textContent = message || '';
  }

  function submitReview(modal, widget) {
    var form = modal.querySelector('.kg-reviews-form');
    var rating = form.querySelector('input[name="rating"]').value;
    var name = form.querySelector('input[name="name"]').value.trim();
    var email = form.querySelector('input[name="email"]').value.trim();
    var title = form.querySelector('input[name="title"]').value.trim();
    var body = form.querySelector('textarea[name="body"]').value.trim();
    if (!rating) {
      formError(modal, t('errorRating'));
      return;
    }
    if (!name || !email || !body) {
      formError(modal, t('errorRequired'));
      return;
    }
    formError(modal, '');
    var submit = form.querySelector('.kg-reviews-form__submit');
    submit.disabled = true;
    var data = new FormData();
    var shop = shopDomain();
    data.append('url', shop);
    data.append('shop_domain', shop);
    data.append('platform', 'shopify');
    data.append('id', reviewProductId(widget));
    data.append('name', name);
    data.append('email', email);
    data.append('rating', rating);
    if (title) data.append('title', title);
    data.append('body', body);
    fetch('https://api.judge.me/api/v1/reviews', { method: 'POST', body: data })
      .then(function (response) {
        return response.json().then(function (payload) {
          return { ok: response.ok, payload: payload };
        });
      })
      .then(function (result) {
        submit.disabled = false;
        if (!result.ok) {
          formError(modal, (result.payload && result.payload.message) || t('errorSubmit'));
          return;
        }
        form.hidden = true;
        var success = modal.querySelector('.kg-reviews-form__success');
        success.hidden = false;
        success.textContent = t('success');
        form.reset();
        paintFormStars(form, 0);
      })
      .catch(function () {
        submit.disabled = false;
        formError(modal, t('errorSubmit'));
      });
  }

  function ensureToolbar(widget) {
    var body = widget.querySelector('.jdgm-rev-widg__body');
    if (!body) return;

    var toolbar = body.querySelector('.kg-reviews-toolbar');
    if (!toolbar) {
      toolbar = document.createElement('div');
      toolbar.className = 'kg-reviews-toolbar';
      toolbar.innerHTML =
        '<div class="kg-reviews-filter">' +
        FILTER_SVG +
        '<span class="kg-reviews-filter__label"></span></div>' +
        '<p class="kg-reviews-count"></p>';
      body.insertBefore(toolbar, body.firstChild);
    }

    var filter = toolbar.querySelector('.kg-reviews-filter');
    var sort = widget.querySelector('.jdgm-rev-widg__sort-wrapper');
    if (sort && filter && sort.parentElement !== filter) filter.appendChild(sort);

    var filterLabel = toolbar.querySelector('.kg-reviews-filter__label');
    setText(filterLabel, t('filter'));
    var sortSelect = widget.querySelector('.jdgm-sort-dropdown');
    if (sortSelect) {
      sortSelect.setAttribute('aria-label', t('filter'));
      Array.prototype.forEach.call(sortSelect.options, function (option) {
        if (option.value === 'recent') setText(option, t('sortRecent'));
        else if (option.value === 'highest') setText(option, t('sortHighest'));
        else if (option.value === 'lowest') setText(option, t('sortLowest'));
      });
    }

    var count = toolbar.querySelector('.kg-reviews-count');
    setText(count, reviewLabel(reviewCount(widget)));

    var button = body.querySelector('.kg-reviews-more');
    if (!button) {
      button = document.createElement('button');
      button.type = 'button';
      button.className = 'kg-reviews-more';
      var paginate = body.querySelector('.jdgm-paginate');
      if (paginate) body.insertBefore(button, paginate);
      else body.appendChild(button);
      button.addEventListener('click', function () {
        showMore(widget, button);
      });
    }
    setText(button, t('showMore'));

    var pool = widget._kgPool;
    var next = widget.querySelector('.jdgm-paginate__next-page');
    var loaded = widget.querySelectorAll('.jdgm-rev').length;
    button.hidden = pool ? pool.length === 0 : !next && loaded >= reviewCount(widget);
  }

  function formatReview(review) {
    if (review.getAttribute('data-kg-ready') === 'true') return;
    review.setAttribute('data-kg-ready', 'true');

    var header = review.querySelector('.jdgm-rev__header');
    if (!header) return;

    if (review.getAttribute('data-verified-buyer') === 'true' && !header.querySelector('.kg-verified')) {
      var badge = document.createElement('span');
      badge.className = 'kg-verified';
      badge.innerHTML = CHECK_SVG + '<span>' + t('verified') + '</span>';
      var wrap = header.querySelector('.jdgm-rev__buyer-badge-wrapper') || header;
      wrap.appendChild(badge);
    }

    if (header.querySelector('.kg-reviews-meta')) return;
    var time = review.querySelector('.jdgm-rev__timestamp');
    var authorEl = review.querySelector('.jdgm-rev__author');
    var author = authorEl ? authorEl.textContent.replace(/\s+/g, ' ').trim() : '';
    var dateText = time ? formatDate(time.getAttribute('datetime') || time.getAttribute('data-content')) : '';
    var meta = document.createElement('p');
    meta.className = 'kg-reviews-meta';
    if (dateText && author) meta.textContent = dateText + ' ' + t('by') + ' ' + author;
    else meta.textContent = dateText || author;
    header.appendChild(meta);
  }

  function formatReviews(widget) {
    widget.querySelectorAll('.jdgm-rev').forEach(formatReview);
  }

  function showMore(widget, button) {
    if (loadingMore || button.hidden) return;
    if (widget._kgPool) {
      var poolList = widget.querySelector('.jdgm-rev-widg__reviews');
      if (!poolList) return;
      widget._kgPool.splice(0, 5).forEach(function (node) {
        poolList.appendChild(node);
      });
      formatReviews(widget);
      button.hidden = widget._kgPool.length === 0;
      return;
    }
    var next = widget.querySelector('.jdgm-paginate__next-page');
    var list = widget.querySelector('.jdgm-rev-widg__reviews');
    if (!next || !list) {
      button.hidden = true;
      return;
    }

    loadingMore = true;
    button.disabled = true;
    var saved = Array.prototype.slice.call(list.children);
    var firstId = list.querySelector('.jdgm-rev') && list.querySelector('.jdgm-rev').getAttribute('data-review-id');
    var finished = false;

    function finish() {
      if (finished) return;
      var currentFirst = list.querySelector('.jdgm-rev');
      var currentId = currentFirst && currentFirst.getAttribute('data-review-id');
      if (currentId === firstId && list.querySelectorAll('.jdgm-rev').length <= saved.length) return;
      finished = true;
      observer.disconnect();
      var seen = {};
      list.querySelectorAll('.jdgm-rev').forEach(function (review) {
        seen[review.getAttribute('data-review-id')] = true;
      });
      var fragment = document.createDocumentFragment();
      saved.forEach(function (node) {
        var id = node.getAttribute && node.getAttribute('data-review-id');
        if (id && !seen[id]) fragment.appendChild(node);
      });
      if (fragment.childNodes.length) list.insertBefore(fragment, list.firstChild);
      loadingMore = false;
      button.disabled = false;
      enhance();
    }

    var observer = new MutationObserver(finish);
    observer.observe(list, { childList: true });
    next.click();

    window.setTimeout(function () {
      if (finished) return;
      observer.disconnect();
      fetchNext(widget, list).finally(function () {
        loadingMore = false;
        button.disabled = false;
        enhance();
      });
    }, 1600);
  }

  function fetchNext(widget, list) {
    var page = parseInt(widget.getAttribute('data-kg-page') || '1', 10) + 1;
    var perPageEl = widget.querySelector('.jdgm-paginate');
    var perPage = (perPageEl && perPageEl.getAttribute('data-per-page')) || '5';
    var id = root.getAttribute('data-product-id') || root.getAttribute('data-id');
    var url = reviewsUrl(id, page, perPage);

    return fetch(url)
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        var holder = document.createElement('div');
        holder.innerHTML = data.html || '';
        var seen = {};
        list.querySelectorAll('.jdgm-rev').forEach(function (review) {
          seen[review.getAttribute('data-review-id')] = true;
        });
        var added = 0;
        holder.querySelectorAll('.jdgm-rev').forEach(function (review) {
          var id = review.getAttribute('data-review-id');
          if (!seen[id]) {
            list.appendChild(review);
            added += 1;
          }
        });
        if (added > 0) widget.setAttribute('data-kg-page', String(page));
        var button = widget.querySelector('.kg-reviews-more');
        var total = typeof data.total_count === 'number' ? data.total_count : reviewCount(widget);
        if (button && (added === 0 || list.querySelectorAll('.jdgm-rev').length >= total)) button.hidden = true;
      })
      .catch(function () {});
  }

  function needsEnhance(widget) {
    if (!widget) return false;
    var header = widget.querySelector('.jdgm-rev-widg__header');
    if (!header) return false;
    if (!header.querySelector('.kg-reviews-trust')) return true;
    if (!header.querySelector('.kg-reviews-score')) return true;
    if (!header.querySelector('.kg-reviews-write')) return true;
    if (widget.querySelector('.jdgm-rev-widg__body') && !widget.querySelector('.kg-reviews-toolbar')) return true;
    if (widget.querySelector('.jdgm-rev:not([data-kg-ready="true"])')) return true;
    return false;
  }

  function bindRefreshHooks(widget) {
    if (!widget || widget.getAttribute('data-kg-hooks') === 'true') return;
    widget.setAttribute('data-kg-hooks', 'true');

    function later() {
      window.setTimeout(function () {
        enhance();
      }, 350);
    }

    var sort = widget.querySelector('.jdgm-sort-dropdown');
    if (sort) sort.addEventListener('change', later);

    widget.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      if (
        target.closest(
          '.jdgm-paginate__page, .jdgm-paginate__next-page, .jdgm-paginate__prev-page, .jdgm-histogram__row, .jdgm-write-rev-link'
        )
      ) {
        later();
      }
    });
  }

  function enhance() {
    if (!root) return;
    var widget = root.querySelector('.jdgm-rev-widg');
    if (!widget) return;
    ensureCard(widget);
    ensureToolbar(widget);
    formatReviews(widget);
    bindRefreshHooks(widget);
  }

  function resetReview(review) {
    review.removeAttribute('data-kg-ready');
    var meta = review.querySelector('.kg-reviews-meta');
    var badge = review.querySelector('.kg-verified');
    if (meta) meta.remove();
    if (badge) badge.remove();
  }

  function applyLocalSort(widget, mode) {
    widget.setAttribute('data-kg-sort', mode || 'recent');
    var filter = parseInt(widget.getAttribute('data-kg-filter') || '0', 10);
    var all = (widget._kgAll || []).slice();
    if (filter) {
      all = all.filter(function (review) {
        return Math.round(scoreOf(review)) === filter;
      });
    }
    if (mode === 'highest') all.sort(function (a, b) { return scoreOf(b) - scoreOf(a); });
    else if (mode === 'lowest') all.sort(function (a, b) { return scoreOf(a) - scoreOf(b); });
    var list = widget.querySelector('.jdgm-rev-widg__reviews');
    if (!list) return;
    list.innerHTML = '';
    all.slice(0, 5).forEach(function (node) {
      resetReview(node);
      list.appendChild(node);
    });
    widget._kgPool = all.slice(5);
    var button = widget.querySelector('.kg-reviews-more');
    if (button) button.hidden = widget._kgPool.length === 0;
    formatReviews(widget);
  }

  function mountHost(carousel) {
    var host = document.createElement('div');
    host.className = 'kg-reviews-host';
    var block = carousel.closest('.shopify-app-block');
    var page = carousel.closest('.page-width') || (carousel.closest('.shopify-section') && carousel.closest('.shopify-section').querySelector('.page-width'));
    if (page && block && page.contains(block)) page.insertBefore(host, block);
    else if (block && block.parentNode) block.parentNode.insertBefore(host, block);
    else carousel.parentNode.insertBefore(host, carousel);
    return host;
  }

  function parseReviews(html) {
    var holder = document.createElement('div');
    holder.innerHTML = html || '';
    return Array.prototype.slice.call(holder.querySelectorAll('.jdgm-rev'));
  }

  function fetchAllReviews(id) {
    return fetch(reviewsUrl(id, 1, 30))
      .then(function (response) { return response.json(); })
      .then(function (first) {
        var firstReviews = parseReviews(first.html);
        var total = typeof first.total_count === 'number' ? first.total_count : firstReviews.length;
        var pageSize = firstReviews.length || 30;
        var pages = Math.min(40, Math.ceil(total / pageSize));
        var requests = [];
        var page;
        for (page = 2; page <= pages; page += 1) {
          requests.push(fetch(reviewsUrl(id, page, pageSize)).then(function (response) { return response.json(); }));
        }
        return Promise.all(requests).then(function (rest) {
          var seen = {};
          var reviews = [];
          firstReviews.concat(rest.reduce(function (all, data) {
            return all.concat(parseReviews(data.html));
          }, [])).forEach(function (review) {
            var reviewId = review.getAttribute('data-review-id');
            if (reviewId && seen[reviewId]) return;
            if (reviewId) seen[reviewId] = true;
            reviews.push(review);
          });
          return { reviews: reviews, total: total };
        });
      });
  }

  function buildFromReviews(carousel) {
    var id = productId();
    if (!id) {
      building = false;
      return;
    }
    hideCarousels();
    fetchAllReviews(id)
      .then(function (data) {
        var reviews = data.reviews;
        if (!reviews.length) {
          /* Product has 0 reviews — keep store carousel hidden (do not re-show it). */
          hideCarousels();
          building = false;
          return;
        }
        var counts = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
        var sum = 0;
        reviews.forEach(function (review) {
          var score = scoreOf(review);
          var bucket = Math.round(score);
          if (counts[bucket] != null) counts[bucket] += 1;
          sum += score;
        });
        var total = data.total || reviews.length;
        var average = sum / reviews.length;
        var host = mountHost(carousel);
        var widgetRoot = document.createElement('div');
        widgetRoot.id = 'judgeme_product_reviews';
        widgetRoot.className = 'jdgm-widget jdgm-review-widget';
        widgetRoot.setAttribute('data-product-id', id);
        widgetRoot.setAttribute('data-kg-source', 'api');
        widgetRoot.setAttribute('data-kg-booted', 'true');
        widgetRoot.innerHTML =
          '<div class="jdgm-rev-widg" data-average-rating="' +
          average.toFixed(2) +
          '" data-number-of-reviews="' +
          total +
          '">' +
          '<div class="jdgm-rev-widg__header">' +
          '<h2 class="jdgm-rev-widg__title"></h2>' +
          '<div class="jdgm-rev-widg__summary">' +
          '<div class="jdgm-rev-widg__summary-stars" role="img" aria-label="' +
          average.toFixed(1) +
          ' stars">' +
          starSpans(average) +
          '</div>' +
          '<div class="jdgm-rev-widg__summary-text"></div>' +
          '</div>' +
          histogramHtml(counts, reviews.length) +
          '<button type="button" class="kg-reviews-write"></button>' +
          '</div>' +
          '<div class="jdgm-rev-widg__body">' +
          '<div class="jdgm-rev-widg__sort-wrapper jdgm-sort-dropdown-wrapper">' +
          '<select class="jdgm-sort-dropdown">' +
          '<option value="recent"></option>' +
          '<option value="highest"></option>' +
          '<option value="lowest"></option>' +
          '</select></div>' +
          '<div class="jdgm-rev-widg__reviews"></div>' +
          '</div></div>';
        host.appendChild(widgetRoot);
        root = widgetRoot;
        var widget = widgetRoot.querySelector('.jdgm-rev-widg');
        widget._kgAll = reviews;
        var select = widget.querySelector('.jdgm-sort-dropdown');
        if (select) {
          select.addEventListener('change', function () {
            applyLocalSort(widget, select.value);
          });
        }
        applyLocalSort(widget, 'recent');
        enhance();
      })
      .catch(function () {
        hideCarousels();
        building = false;
      });
  }

  function boot() {
    var existing = document.getElementById('judgeme_product_reviews');
    if (existing) {
      root = existing;
      var widget = existing.querySelector('.jdgm-rev-widg');
      if (!widget || !widget.querySelector('.jdgm-rev-widg__header')) return false;

      if (existing.getAttribute('data-kg-placed') !== 'true') {
        existing.setAttribute('data-kg-placed', 'true');
        existing.setAttribute('data-kg-booted', 'true');
        hideCarousels();
        place(existing);
      }

      /* 0-review product widget stays hidden via CSS; still hide store carousel. */
      if (reviewCount(widget) === 0) {
        hideCarousels();
        return true;
      }

      if (needsEnhance(widget)) enhance();
      else bindRefreshHooks(widget);

      return !needsEnhance(widget);
    }

    if (building || document.querySelector('.kg-reviews-host')) {
      var hostWidget = document.querySelector('.kg-reviews-host .jdgm-rev-widg');
      if (hostWidget) {
        root = hostWidget.closest('#judgeme_product_reviews') || hostWidget.parentElement;
        if (needsEnhance(hostWidget)) enhance();
        return !needsEnhance(hostWidget);
      }
      return false;
    }

    var carousel = document.querySelector('.jdgm-carousel-wrapper, .jdgm-widget.jdgm-carousel');
    if (!carousel) return false;
    building = true;
    buildFromReviews(carousel);
    return false;
  }

  /* Poll until Judge.me is ready — no MutationObservers (those froze the page). */
  var tries = 0;
  function tick() {
    var done = false;
    try {
      done = boot();
    } catch (err) {
      done = true;
    }
    if (done || ++tries > 60) return;
    window.setTimeout(tick, 250);
  }
  tick();
})();
